



























































































































































import Vue from "vue";
import { mapState } from "vuex";
import { Rules, asyncRoutes } from "@/router/routes";
import TenantSelect from "./TenantSelect.vue";
import ProjectSelect from "./ProjectSelect.vue";
import { eventBus } from "../../utils/event";
export default Vue.extend({
  name: "MyMenu",
  components: { TenantSelect, ProjectSelect },
  data() {
    return {
      activeMenu: "SYS",
      menus: {},
      isCollapse: false,
      title: null as any
    };
  },
  computed: {
    ...mapState("LoginInfo", ["userinfo", "tenantId"]),
    metaName() {
      return this.$route.meta?.name;
    },
    // 根据路由判断是否属于应用菜单
    isPrjMenu() {
      return this.$route.meta.isPrjMenu;
    }
  },
  watch: {
    userinfo: {
      deep: true,
      immediate: true,
      handler(info: any) {
        if (!info) return;
        // @ts-ignore
        this.setMenus(info);
      }
    },
    $route: {
      immediate: true,
      handler(route) {
        if (route.meta && route.meta.rule) {
          switch (route.meta.rule) {
            case "MENU_TENANT":
              // @ts-ignore
              this.activeMenu = "TENANT";
              break;

            default:
              // @ts-ignore
              this.activeMenu = "SYS";
              break;
          }
        }
      }
    }
  },
  mounted() {
    // @ts-ignore
    eventBus.$on("collapse", this.collapse);
  },
  beforeDestroy() {
    // @ts-ignore
    eventBus.$off("collapse", this.collapse);
  },
  methods: {
    setMenus(info: any) {
      const menus: any = {};

      (info.menus as Rules[]).forEach(item => {
        if (item === "MENU_TENANT") {
          menus.TENANT = {
            name: "我的空间",
            children: [],
            // 应用菜单
            prjMenus: []
          };
        } else {
          menus.SYS = {
            name: "系统管理",
            children: []
          };
        }
      });

      asyncRoutes.forEach(item => {
        if (item.meta?.rule === "MENU_TENANT" && menus.TENANT) {
          if (item.meta.isPrjMenu) {
            (menus.TENANT.prjMenus as any[]).push(
              Object.assign({}, item.meta, {
                path: item.path,
                routeName: item.name
              })
            );
          } else {
            (menus.TENANT.children as any[]).push(
              Object.assign({}, item.meta, {
                path: item.path,
                routeName: item.name
              })
            );
          }
        } else if (
          (info.menus as Rules[]).includes(item.meta?.rule as Rules) &&
          menus.SYS
        ) {
          (menus.SYS.children as any[]).push(
            Object.assign({}, item.meta, {
              path: item.path,
              routeName: item.name
            })
          );
        }
      });
      // @ts-ignore
      this.menus = menus;
    },
    menuChange(key: string) {
      // @ts-ignore
      if (this.activeMenu === key) return;
      // @ts-ignore
      if (key === "SYS") {
        if (this.userinfo.menus.includes("MENU_ADMIN")) {
          this.$router.push({ name: "Overview" });
        } else {
          // 运维权限
          this.$router.push({ name: "Cluster" });
        }
      } else {
        this.$router.push({
          name: "TanOverview",
          params: { tenantId: this.tenantId }
        });
      }
    },
    collapse() {
      // @ts-ignore
      this.isCollapse = !this.isCollapse;
    },
    menuEnter(e: any, name: string) {
      // @ts-ignore

      if (!this.isCollapse) return;
      // @ts-ignore
      this.title = document.createElement("div");
      // @ts-ignore
      this.title.innerHTML = name;
      // @ts-ignore
      this.title.classList.add("fix-title");
      // @ts-ignore
      this.title.style.lineHeight = `${e.target.offsetHeight}px`;
      // @ts-ignore
      this.title.style.top = `${e.target.offsetTop +
        // @ts-ignore
        this.$refs.nav.offsetTop +
        60 +
        (this.isPrjMenu ? 50 : 0)}px`;
      // @ts-ignore
      document.body.appendChild(this.title);
    },
    menuLeave() {
      // @ts-ignore
      if (!this.isCollapse || !this.title) return;
      // @ts-ignore
      document.body.removeChild(this.title as HTMLElement);
    }
  }
});
